// extracted by mini-css-extract-plugin
export default {"sale-history":"sale-history-accordion_sale-history__raS48","sale-history-entries":"sale-history-accordion_sale-history-entries__akedl"};